/**
* @name: SpaceSelItem
* @author: weiyong
* @date: 2022-10-02 09:13
* @description：SpaceSelItem
* @update: 2022-10-02 09:13
*/
<template>
  <div class="space-sel-item" :class="[prefixCls,isHomePage?'activeSpaceItem':'activeNotSpaceItem']"
       v-if="getPcSpaceList&&getPcSpaceList.length>1"
       style="font-size: 18px;">
    <AppstoreOutlined/>
    <span class="label">{{ getCurSpaceItem && getCurSpaceItem.name }}</span>
    <div class="space-sel-panel" :style="panelSty">
      <div class="space-item" @click="selSpaceItemFun(spaceItem)"
           v-for="spaceItem in getPcSpaceList"
           :class="showActiveItem&&getCurSpaceItem&&spaceItem.id===getCurSpaceItem.id?'active':''">
        <div class="space-item-icon">
          <AppstoreOutlined/>
        </div>
        <div class="space-item-label">{{ spaceItem.name }}</div>
      </div>
    </div>
  </div>

</template>

<script lang="ts">
export default {
  name: "SpaceSelItem"
}
</script>

<script lang="ts" setup>
import {useSpaceHook} from '@/hooks/layouts/useSpaceHook';
import {usePcSpaceStore} from "@/store/pcSpaceStore";
import {AppstoreOutlined} from '@ant-design/icons-vue';
import {useDesign} from "@/hooks/web/useDesign";
import {computed, nextTick, reactive, ref, toRefs, unref, watch} from "vue";
import {useRouter} from "vue-router";
import eventBus from "@/events/eventBus";
import {StorageUtils} from 'xmgoing-utils';
import {REDIRECT_NAME} from "@/router/constant";
import {PageEnum} from "@/enums/pageEnum";

const showActiveItem=ref(true);
const {prefixCls} = useDesign('SpaceSelItem');
const {
  panelSty,
  getPcSpaceList,
  getCurSpaceItem,
  selAppSpaceItem,
  selSpaceItem,
  clearCurSpaceItem,
} = useSpaceHook();
const pcSpaceStore = usePcSpaceStore();
const props = defineProps({
  spaceType: {
    type: String,
    default: 'main'
  }
});
const {spaceType} = toRefs(props);
const isHomePage=ref(false);


const router = useRouter();
const selSpaceItemFun = (itemObj) => {
  pcSpaceStore.setLoadingFlag(true);
  //如果是首页设计页面
  if(window.appObj.analysisSet){
    return false;
  }
  const userId=StorageUtils.getSessionItem('userId');
  StorageUtils.addSessionItem(userId+"_curSelSpaceItem",unref(itemObj).id)
  if (unref(spaceType) === 'app') {
    router.push({path: '/dashboard/appMainPage'});
    nextTick(() => {
      selAppSpaceItem(itemObj);
    })
  } else {
    router.push({path: '/dashboard'});
    nextTick(() => {
      selSpaceItem(itemObj);
    })
  }
}
const _setShowActiveItem=function({flag}){
  showActiveItem.value=flag;
}
onBeforeUnmount(()=>{
  eventBus.off('setShowActiveItem',_setShowActiveItem);
})
onMounted(()=>{
  eventBus.off('setShowActiveItem',_setShowActiveItem);
  eventBus.on('setShowActiveItem',_setShowActiveItem);
})

const { currentRoute } = useRouter();
watch(
  [() => currentRoute.value.path],
  () => {
    if(PageEnum.BASE_HOME_URL===currentRoute.value.path){
      isHomePage.value=true;
    }else{
      isHomePage.value=false;
      clearCurSpaceItem();
    }
  }
);
</script>

<style type="text/css" lang="less">
@header-app: 36px;
@sub-header-app: 50px;
@prefix-cls: ~'@{namespace}-SpaceSelItem';
/**
  APP模式下
 */
.@{namespace}-layout-header-app--light {

  .@{prefix-cls} {
    &.space-sel-item:hover {
      background-color: @header-light-bg-hover-color;
      .space-sel-panel {
        color: #333;
      }
    }
  }
}

/**
  APP模式下
 */
.@{namespace}-layout-header-app--dark {
  .@{prefix-cls} {
    &.space-sel-item:hover {
      background-color: @header-dark-bg-hover-color;

      .space-sel-panel {
        color: #333;
      }
    }
  }
}

/**
  传统模式下
 */
.@{namespace}-layout-multiple-header--dark {
  .ant-layout-header {
    .@{prefix-cls} {
      height: 48px;

      .space-sel-panel {
        top: calc(43px - 1px);
      }

      .space-sel-panel {
        color: #333;
      }

      &:hover {
        background-color: @header-dark-bg-hover-color;
      }
    }
  }
}

/**
  传统模式下
 */
.@{namespace}-layout-multiple-header--light {
  .ant-layout-header {
    .@{prefix-cls} {
      height: 48px;
      color: #333;

      .space-sel-panel {
        top: calc(48px - 1px);
      }

      .space-sel-panel {
        color: #333;
      }

      &:hover {
        background-color: @header-light-bg-hover-color;
      }
    }
  }
}

.defaultFrame{
  .@{prefix-cls} {
    --el-color-primary-light-8: rgba(0,0,0,0.16);
    --system-com-raduis:4px;
  }
  .vben-layout-header--light{
    .@{prefix-cls} {
      --el-color-primary-light-8: rgba(200,200,200,0.3);
      --system-com-raduis:4px;
    }
  }
  .vben-layout-multiple-header--light .ant-layout-header .vben-SpaceSelItem {
    height: 33px;
    color: #333;
    .space-sel-panel{
      top: calc(33px - 1px);
    }
  }
  .vben-layout-multiple-header--dark .ant-layout-header .vben-SpaceSelItem{
    height: 38px;
    .space-sel-panel{
      top: calc(38px - 1px);
    }
  }
}

.@{prefix-cls} {
  --el-color-primary-light-8: #cce2fb;

  &.space-sel-item {
    font-size: 18px;
    display: flex;
    padding: 1px 10px 0;
    cursor: pointer;
    align-items: center;
    position: relative;
    border-radius: var(--system-com-raduis,8px);

    &.activeSpaceItem{
      background-color: var(--el-color-primary-light-8,#f6f6f6);
    }

    .label {
      font-size: 13px;
      display: inline-block;
      padding-left: 4px;

    }

    &:hover {
      background-color:var(--el-color-primary-light-8,#f6f6f6);

      .space-sel-panel {
        display: flex;
        transition: height cubic-bezier(.2, 0, 0, 1) .2s;
      }
    }

    &.appSpaceSelItem {
      .space-sel-panel {
        top: calc(@sub-header-app - 2px);
      }
    }

    .space-sel-panel {
      border: 1px solid #dfdfdf;
      position: absolute;
      top: calc(@header-app - 2px);
      background-color: #FFF;
      transition: display cubic-bezier(.2, 0, 0, 1) .2s;
      box-shadow: 0 4px 6px 0 rgb(12 31 80 / 4%);
      left: 0;
      z-index: 1070;
      cursor: auto;
      padding: 0 12px;
      padding-top: 12px;
      padding-right: 0;
      max-width: 300px;
      flex-wrap: wrap;
      -webkit-user-select: text;
      -moz-user-select: text;
      -ms-user-select: text;
      user-select: text;
      white-space: normal;
      font-size: 12px;
      display: none;
      line-height: 1.6;
      font-weight: 400;
      text-align: left;


      .space-item-icon {
        font-size: 24px;
        text-align: center;
        width: 100%;
      }

      .space-item-label {
        width: 100%;
        text-align: center;
      }

      .space-item {
        border: 1px solid #dfdfdf;
        flex-wrap: wrap;
        width: 80px;
        padding: 6px 0;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 12px 12px 0;
        cursor: pointer;

        &:hover {
          background-color: @header-light-bg-hover-color;
        }

        &.active {
          background-color: @primary-color;
          color: #FFF;
        }
      }
    }
  }
}
</style>
